import { Editor } from 'slate'

export const withImages = (editor: Editor) => {
  const { isVoid } = editor

  editor.isVoid = element => (element.type === 'image' ? true : isVoid(element))

  return editor
}
